module.exports = __webpack_public_path__ + "assets/img/logo-paypal.0de0d223.png";